/**
 * Created by andrey on 09.06.2023
 */

const EmailWindow = CleverappsWindow.extend({
    onWindowLoaded: function (callback) {
        this.callback = callback;

        this._super({
            title: Messages.get("EmailWindow.title"),
            content: this.createContent(),
            button: {
                text: Messages.get("OK"),
                onPressed: this.onPressed.bind(this)
            },
            notCloseByTouchInShadow: true
        });
    },

    onPressed: function () {
        const email = this.editBox.getString().toLowerCase().trim();

        if (!cleverapps.validateEmail(email)) {
            cleverapps.notification.create(Messages.get("EmailWindow.error"));
            return;
        }

        this.email = email;

        cleverapps.info.setKeyValue("email", email);

        this.close();
    },

    onClose: function () {
        this.callback && this.callback(this.email);
    },

    createContent: function () {
        const styles = cleverapps.styles.EmailWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.get("EmailWindow.text"), cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.text.width, 0);

        const placeHolder = cleverapps.country.getCountry() === "RU" || connector.payments.oneOf(connector.YOOKASSA)
            ? "your_email@yandex.ru"
            : "your_email@gmail.com";

        const editBoxBg = new cc.Scale9Sprite(bundles.windows.frames.editbox_bg_png);
        const editBox = this.editBox = new cc.EditBox(styles.editBox, editBoxBg, true);

        editBox.setPlaceholderFontColor(cleverapps.styles.FONTS.EMAIL_WINDOW_PLACEHOLDER_TEXT.color);
        editBox.setPlaceholderFont(cleverapps.UI.getFontName(), cleverapps.styles.FONTS.EMAIL_WINDOW_PLACEHOLDER_TEXT.size);
        editBox.setPlaceHolder(placeHolder);

        editBox.setInputMode(cc.EDITBOX_INPUT_MODE_EMAILADDR);
        editBox.setMaxLength(100);
        editBox.stayOnTop(true);
        editBox.setTouchEnabled();
        editBox.setFontColor(cleverapps.styles.FONTS.EMAIL_WINDOW_EDITBOX_TEXT.color);
        editBox.setFont(cleverapps.UI.getFontName(), cleverapps.styles.FONTS.EMAIL_WINDOW_EDITBOX_TEXT.size);

        const email = cleverapps.info.getValue("email");
        if (email) {
            editBox.setString(email);
        }

        return new cleverapps.Layout([text, editBox], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin,
            padding: styles.padding
        });
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    EMAIL_WINDOW_EDITBOX_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE
    },

    EMAIL_WINDOW_PLACEHOLDER_TEXT: {
        size: 30,
        color: cc.color.GRAY
    }
});

cleverapps.styles.EmailWindow = {
    margin: 60,
    padding: {
        top: 70,
        bottom: 40
    },

    text: {
        width: 650
    },

    editBox: {
        width: 550,
        height: 50
    }
};